// assets
import Arrow from "assets/icons/forward.svg";
import Gdot from "assets/icons/green-dot.svg";
import Check2 from "assets/icons/pop-check.svg";
import Rdot from "assets/icons/red-dot.svg";
import Cancel from "assets/icons/sm-x.svg";
import Back from "assets/svg/back-arrow.svg";
import Load from "assets/svg/other/loading2.svg";
import NextIcon from "assets/svg/other/page/nextp.svg";
import Icon2 from "assets/svg/other/page/prevp.svg";
import Header from "components/dashHeader";
import PaymentMethods from "components/send/paymentMethods";
// components
import Sidemenu from "components/sidemenu";
import Toggle from "components/toggle";
import { debounce } from "lodash/function";
import { StyledDiv } from "pages/dashboard/home/HomeReceive";
//css
import "pages/styles/dashboard/Home.css";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { get, post } from "util/axiosLib";
import { logger } from "util/logger";
import {
    getExchangeRate,
    getParameterByName,
    isEmpty,
    properCase,
    wordCut
} from "util/utils";
import { SendCard } from "./SendPage";

//import AllBanks from "../../../components/allBanks";
//import BankOptions from "components/bankOptions";

export default class HomeSend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bankLoaded: false,
      pageState: "loading",
      fetchedReceivables: false,
      popUpClicked: false,
      summaryClicked: false,
      selectedCoin: "xrp",
      selectedFiat: "ngn",
      exchangeRate: 0,
      coinAmount: 0,
      fiatAmount: 0,
      //ghsStatus: false,
      enterPin: false,
      paymentMethod: " ",
      banks: [],
      useSpotRate: true,
      useDestinationVolume: true,
      transactionsView: "pending",
      pageLimit: 4,
      currentPage: 1,
      stPages: 1,
      sendView: "create",
      dataLoading: false,
      txCount: 0,
      allTx: [],
      wordLen: 0,
      windowWidth: 0,
      windowHeight: 0,
      sendRef: "",
      sendData: {},
    };

    // Debounce
    this.bankCheck = debounce(this.bankCheck, 2000);

    this.token = localStorage.getItem("tokenset");
    this.userData = JSON.parse(localStorage.getItem("btm_user"));
    this.headers = {
      authorization: `${this.token}`,
      "Content-Type": "application/json",
    };

    this.calculateCoinValue = debounce(this.calculateCoinValue, 2000);
    this.calculateFiatValue = debounce(this.calculateFiatValue, 2000);

    this.fiatAmount = React.createRef();
    this.coinAmount = React.createRef();
  }

  refresh = () => this.fetchReceivables();

  nextPages = () => {
    const { currentPage, stPages } = this.state;
    if (currentPage < stPages) this.setState({ currentPage: currentPage + 1 });
  };

  prevPages = () => {
    const { currentPage } = this.state;

    if (currentPage > 1) this.setState({ currentPage: currentPage - 1 });
  };

  fetchReceivables = async () => {
    const { token } = this.props;
    const { transactionsView, pageLimit, currentPage } = this.state;
    try {
      const headers = {
        authorization: `${token}`,
        "Content-Type": "application/json",
      };
      // 'open', 'cancelled', 'closed', 'timeout'
      const whichState =
        transactionsView === "closed"
          ? "gone,failed,reversed,cancelled,timeout"
          : transactionsView === "pending"
          ? "open"
          : "going";

      const baseUrl = `${process.env.REACT_APP_API_ENDPOINT}/wallet/send/across?status=${whichState}&limit=${pageLimit}&page=${currentPage}`;
      this.setState({ dataLoading: true });

      const getTransactionsReq = await get(baseUrl, headers);

      const rawTx = getTransactionsReq?.data?.data;
      const receivedTx = rawTx?.sends;

      const newTx = Array.isArray(receivedTx)
        ? receivedTx
        : Array.from(receivedTx);
      const newTxCount = isNaN(rawTx?.totalCount)
        ? 0
        : Number(rawTx?.totalCount);

      this.setState({
        dataLoading: false,
        txCount: newTxCount,
        allTx: newTx,
        fetchedReceivables: true,
        stPages: isNaN(newTxCount)
          ? 1
          : parseInt(Number(newTxCount - 1) / this.state.pageLimit) + 1,
      });
    } catch (err) {
      if (err?.isAxiosError) {
        if (err?.response?.status === 401) {
          // return localsocket && localsocket?.emit("LOGOUT")
        }
      } else {
        logger("ERROR:: ", err);
      }
      this.setState({ dataLoading: false });
      // setTransactionError(String(err))
    }
  };

  fetchReceivable = async (ref) => {
    try {
      const { token } = this.props;

      const headers = {
        authorization: `${token}`,
        "Content-Type": "application/json",
      };
      this.setState({
        pageState: "loading",
      });
      if (isEmpty(this.state.sendRef) && !ref) {
        return this.setState({ pageState: "notFound" });
      }

      const baseUrl = `${
        process.env.REACT_APP_API_ENDPOINT
      }/wallet/send/across/${ref || this.state.sendRef}`;

      const getTransactionsReq = await get(baseUrl, headers);

      const rawTx = getTransactionsReq?.data?.data;

      this.setState({
        pageState: "ready",
        sendData: { ...rawTx },
        lastFectched: new Date(),
      });
    } catch (err) {
      if (err?.isAxiosError) {
        if (err?.response?.status === 401) {
          // return localsocket && localsocket?.emit("LOGOUT");
        } else if (err?.response?.status === 403) {
          return this.setState({ pageState: "notFound" });
        } else if (err?.response?.status === 404) {
          return this.setState({ pageState: "notFound" });
        } else if (err?.response?.status === 500) {
          return this.setState({ pageState: "notFound" });
        }
      } else {
        logger("ERROR:: ", err);
      }
      this.setState({ pageState: "error" });
    }
  };

  loadBanks = async () => {
    try {
      //const reqbody = { }

      const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/banks`;
      const getBankReq = await get(endpoint, this.headers);

      logger(getBankReq);

      const allBankData = getBankReq.data.data.bankPayloads;

      logger("SEND REQ RESPONSE::: ", getBankReq);
      if (getBankReq.data.status === "success") {
        this.setState({
          banks: allBankData,
          bankLoaded: true,
        });
      }

      return Promise.resolve(true);
    } catch (err) {
      if (err.isAxiosError) {
        //const errData = err.response;
        // if (errData?.status === 403 || errData?.status === 401) {
        //   this.setState({
        //     incorrectError: "Token expired, please login again.",
        //   });
        //   setTimeout(() => {
        //     window.location = "/";
        //   }, 2000);
        // }
      }
      return Promise.reject(err);
    }
  };

  bankCheck = async () => {
    try {
      const bankDetails = {
        bankCode: this.state.bankCode,
        bankAccountNumber: this.state.accountNo,
      };

      this.setState({
        accountName: "resolving...",
      });

      const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/banks/resolve`;
      const sendReq = await post(endpoint, bankDetails, this.headers);

      logger("SEND REQ RESPONSE::: ", sendReq);
      if (sendReq.data.status === "success") {
        this.setState({
          accountName: sendReq.data.data.resolved.account_name,
        });
      }
    } catch (err) {
      if (err.isAxiosError) {
        const errData = err.response;
        this.setState({
          errorMessage: errData.data.error.msg,
          accountName: "Error, please check account number",
          //errorBox: true,
        });
        // const errmsg = document.getElementById("error-info");
        // errmsg.classList.add("error-info-on");
        const ebtn = document.getElementById("wi-btn");
        await ebtn.classList.add("w-disable");
      }
    }
  };

  handleSummary = async (event) => {
    event.preventDefault();
    // this.setState({
    //   summaryClicked: false,
    //   popUpClicked: true,
    // });
    await this.setState({
      enterPin: true,
      // summaryClicked: false
    });
  };

  createPin = async () => {
    localStorage.setItem("changePinStatus", true);

    setTimeout(() => {
      window.location = "/dashboard/accountedit";
    }, 1000);
  };

  handlePinSubmit = async (event) => {
    event.preventDefault();

    const ebtn = document.getElementById("summaryBtn");
    await ebtn.classList.add("e-disable");

    //loading..
    const loaded2 = document.getElementById("loadla");
    loaded2.classList.add("load-aa-on");
    try {
      const reqBody = {
        // coin: this.state.selectedCoin,
        // currency: this.state.selectedFiatWallet,
        // price: this.state.fiatAmount,
        // buyPrice: this.state.buyPrice,
        // ticker: this.state.ticker,

        sourceUnit: this.state.selectedCoin,
        sourceVolume: Number(this.state.coinAmount),
        destinationVolume: this.state.fiatAmount
          ? Number(this.state.fiatAmount)
          : 0,
        useDestinationVolume: this.state.useDestinationVolume,
        useBackendRate: this.state.useSpotRate,

        waitTimeUnit: this.state.waitTimeUnit, // (optional) one of ['minutes', 'hours']
        maxWaitTime: this.state.waitTime, // (optional) if the request is not processed in 5 hours, reverse it. one of [1, 5, 10, 24, 48], default is 48 hours,

        destinationUnit: this.state.selectedFiat,
        msg: "",
        receipient: {
          name: this.state.accountName,
          email: this.state.email,
          // phoneNumber: this.state.phoneNumber
        },
        pin: this.state.pin,
        receipientData: {
          receivingIntoAddress: this.state.accountNo,
          receivingIntoLabel: this.state.bank,
          receivingMethod: this.state.paymentMethod,
          receipientContact: this.state.email,
          receipientContactMethod: "email",
          receipientCountry: "Nigeria",
        },
      };

      const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/wallet/send/across`;
      const sendReq = await post(endpoint, reqBody, this.headers);

      logger("SEND REQ RESPONSE::: ", sendReq);
      if (sendReq.data.status === "success") {
        this.setState({
          enterPin: false,
          summaryClicked: false,
          popUpClicked: true,
        });
        // setTimeout(() => {
        //   window.location.reload();
        // }, 4000);
      }
    } catch (err) {
      //console.log("login ERROR::: ", err);
      if (err.isAxiosError) {
        const errData = err.response;
        this.setState({
          errorMessage: errData.data.error,
          //summaryClicked: false,
          //errorBox: true,
        });
        const errmsg = document.getElementById("error-info");
        errmsg.classList.add("error-info-on");

        loaded2.classList.remove("load-aa-on");
        await ebtn.classList.remove("e-disable");
      }
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    // fees
    if (this.state.selectedCoin === process.env.REACT_APP_COIN_A) {
      await this.setState({ fee: 0.0005 });
    }
    if (this.state.selectedCoin === process.env.REACT_APP_COIN_B) {
      await this.setState({ fee: 0.00002 });
    }
    if (this.state.selectedCoin === process.env.REACT_APP_COIN_C) {
      await this.setState({ fee: 0.01 });
    }
    if (this.state.selectedCoin === process.env.REACT_APP_COIN_D) {
      await this.setState({ fee: 0.008 });
    }
    if (this.state.selectedCoin === process.env.REACT_APP_COIN_E) {
      await this.setState({ fee: 0.01 });
    }
    if (
      this.state.selectedCoin === process.env.REACT_APP_COIN_F ||
      this.state.selectedCoin === process.env.REACT_APP_COIN_I
    ) {
      await this.setState({ fee: 1 });
    }
    if (this.state.selectedCoin === process.env.REACT_APP_COIN_G) {
      await this.setState({ fee: 20 });
    }
    if (this.state.selectedCoin === process.env.REACT_APP_COIN_H) {
      await this.setState({ fee: 0.001 });
    }
    const fee = this.state.fee;
    const releaseAmount = this.state.coinAmount - fee;
    await this.setState({ feeTotal: fee, releaseAmount, summaryClicked: true });
  };

  // Handles change in coin selection dropdown
  handleCoinChange = async (event) => {
    this.setState({ selectedCoin: event.target.value });
    if (this.state.coinAmount !== 0) {
      await this.calculateFiatValue(this.state.coinAmount);
    }
  };

  handleFiatChange = async (event) => {
    const value = event.target.value;
    await this.setState({
      selectedFiat: value,
    });
    if (this.state.coinAmount !== 0) {
      await this.calculateFiatValue(this.state.coinAmount);
    }
    // if(this.state.selectedFiat === "ngn"){
    //   this.setState({ paymentMethod : "bank-transfer"})
    // } else {
    //   this.setState({ paymentMethod : " "})
    // }
    if (this.state.selectedFiat === "ghs") {
      await this.setState({ ghsStatus: true });
    } else {
      await this.setState({ ghsStatus: false });
    }
    //logger(this.state.ghsStatus)
  };

  handlePaymentMethod = async (event) => {
    this.setState({
      paymentMethod: event.target.value,
    });
  };

  handleInputChange = async (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    this.setState({
      [name]: value,
    });

    const errmsg = document.getElementById("error-info2");
    errmsg.classList.remove("err-auth-on");
    this.setState({ incorrectError: " " });

    if (name === "coinAmount") {
      await this.calculateFiatValue(value);

      const numberRegex = /(?=[a-zA-Z])/;
      if (numberRegex.test(event.target.value) || event.target.value < 0) {
        const errmsg = document.getElementById("error-info2");
        errmsg.classList.add("err-auth-on");
        this.setState({ incorrectError: "Please enter only valid numbers" });
      }
    }
    if (name === "bank") {
      await this.setState({
        bank: value.split("/")[0],
        bankCode: value.split("/")[1],
      });
    }

    if (name === "accountNo") {
      this.bankCheck();
    }

    if (name === "fiatAmount") {
      await this.calculateCoinValue(value);
    }

    const ebtn = document.getElementById("wi-btn");
    await ebtn.classList.add("w-disable");

    if (this.state.coinAmount > 0) {
      const ebtn = document.getElementById("wi-btn");
      ebtn.classList.remove("w-disable");
    }
  };

  calculateFiatValue = async (coinAmount) => {
    try {
      const usCoins = ["usdt", "cusd", "usdc", "usdt-tron"];
      let coin;
      coin = usCoins.includes(this.state.selectedCoin)
        ? "usd"
        : this.state.selectedCoin;

      if (this.state.selectedCoin === "tbtc") {
        coin = "btc";
      }

      if (this.state.selectedCoin === "teth") {
        coin = "eth";
      }
      if (this.state.selectedCoin === "ceur") {
        coin = "eur";
      }
      const ticker = `${coin}${this.state.selectedFiat}`;
      const exchangeRate = await getExchangeRate(ticker, "sell");
      logger("EXCHANGE RATE:: ", exchangeRate);
      const fiatAmount = Number((exchangeRate * coinAmount).toFixed(2));
      this.fiatAmount.current.value = Number(fiatAmount).toLocaleString();
      this.setState({ fiatAmount, exchangeRate });
    } catch (err) {
      if (err?.isAxiosError) {
        // const errData = err.response;
        if (err?.isAxiosError) {
          if (err.response?.status === 401 || err.response?.status === 403) {
            window.location = "/";
          }
        }
      }
    }
  };

  calculateCoinValue = async (fiatAmount) => {
    try {
      const usCoins = ["usdt", "cusd", "usdc", "usdt-tron"];
      let coin;
      coin = usCoins.includes(this.state.selectedCoin)
        ? "usd"
        : this.state.selectedCoin;

      if (this.state.selectedCoin === "tbtc") {
        coin = "btc";
      }

      if (this.state.selectedCoin === "teth") {
        coin = "eth";
      }
      if (this.state.selectedCoin === "ceur") {
        coin = "eur";
      }
      const ticker = `${coin}${this.state.selectedFiat}`;
      const exchangeRate = await getExchangeRate(ticker, "sell");
      logger("EXCHANGE RATE:: ", exchangeRate);
      const coinAmount = Number((fiatAmount / exchangeRate).toFixed(2));
      this.coinAmount.current.value = Number(coinAmount).toLocaleString();
      this.setState({ coinAmount, exchangeRate });
    } catch (err) {
      if (err?.isAxiosError) {
        // const errData = err.response;
        if (err?.isAxiosError) {
          if (err.response?.status === 401 || err.response?.status === 403) {
            window.location = "/";
          }
        }
      }
    }
  };

  handleRemove = (event) => {
    event.preventDefault();

    this.setState({ popUpClicked: false });
    this.setState({ popUpRemove: true });
    setTimeout(function () {
      document.querySelector("#rem-box").style.display = "none";
    }, 1000);

    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  updateDimensions = () => {
    this.setState({
      widthWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    const sendRef = getParameterByName("id", window.location.search);
    if (isEmpty(sendRef)) {
      this.setState({ sendView: "create" });
      if (!this.state.bankLoaded) this.loadBanks();
      this.fetchReceivables();
    } else {
      this.setState({ sendView: "viewing" });
      this.fetchReceivable(sendRef);
    }
    this.setState({ sendRef });
  }

  wordLen = () =>
    isNaN(this.state.windowWidth)
      ? 50
      : Math.max(50, Math.floor(Number(this.state.windowWidth) / 8));

  async componentDidUpdate(prevProps, prevState) {
    // if(prevState.windowWidth !== this.state.windowHeight) {
    //   const wordLen =
    // }

    if (this.state.sendRef !== prevState.sendRef) {
      if (isEmpty(this.state.sendRef)) {
        this.setState({ sendView: "create" });
        if (!this.state.bankLoaded) this.loadBanks();
        if (!this.state.fetchedReceivables) this.fetchReceivables();
      } else {
        this.setState({ sendView: "viewing" });
        if (!this.state.fetchedReceivables) this.fetchReceivables();
        this.fetchReceivable();
      }
    }
    if (
      this.state.transactionsView !== prevState.transactionsView ||
      this.state.currentPage !== prevState.currentPage
    ) {
      this.fetchReceivables();
    }
  }

  render() {
    const currentPagey = "Home";
    const wordLen = this.wordLen;
    const {
      currentPage,
      stPages,
      transactionsView,
      dataLoading,
      allTx,
      pageLimit,
      txCount,
      pageState,
      sendData,
      sendView,
    } = this.state;

    return (
      <StyledDiv>
        <Sidemenu currentPage={currentPagey} />
        <Header />

        {this.state.popUpClicked ? (
          <div id="rem-box">
            <div className="overlay animate__animated animate__fadeIn "></div>
            <section className="popup">
              <div className="popup-box animate__animated animate__slideInDown">
                <div className="popup-img">
                  <img
                    className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s"
                    src={Check2}
                    alt=""
                  />
                </div>
                {/* <h2>0.00234 Btc</h2> */}
                <p className="popup-success">Sent Successfully</p>
                {/* <p onClick={this.handleRemove} className="popup-close">
                  Close
                </p> */}
                <button onClick={this.handleRemove} className="popup-close-btn">
                  Close
                </button>
                {/* {document.querySelector('#rem-box').style.display = "block"} */}
              </div>
            </section>
          </div>
        ) : null}
        {this.state.popUpRemove === true && (
          <div id="rem-box">
            <div className="overlay animate__animated animate__fadeOut "></div>
            <section className="popup">
              <div className="popup-box animate__animated animate__backOutUp">
                <div className="popup-img">
                  <img
                    className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s"
                    src={Check2}
                    alt=""
                  />
                </div>
                {/* <h2>0.00234 Btc</h2> */}
                <p className="popup-success">Sent Successfully!</p>
                <p onClick={this.handleRemove} className="popup-close">
                  Close
                </p>
              </div>
            </section>
          </div>
        )}

        {this.state.summaryClicked ? (
          <div>
            <div className="overlay animate__animated animate__fadeIn "></div>
            <section className="summaryclicked">
              <div className="summaryclicked-box animate__animated animate__slideInUp">
                <div className="sc-top">
                  <h2 className=""> Send Summary</h2>
                  <img
                    onClick={() => this.setState({ summaryClicked: false })}
                    src={Cancel}
                    alt="close"
                  />
                </div>
                <div className="sc-items">
                  <p className="sc-item-title">
                    {" "}
                    {this.state.selectedCoin.toUpperCase()} Quantity
                  </p>
                  <p>
                    <span className="bold">
                      {Number(this.state.coinAmount).toLocaleString()}
                    </span>{" "}
                    {this.state.selectedCoin.toUpperCase()}{" "}
                  </p>
                </div>
                <div className="sc-items-last">
                  <p className="sc-item-title">Fees (0.5%)</p>
                  <p>
                    <span>{Number(this.state.feeTotal).toLocaleString()} </span>{" "}
                    {this.state.selectedCoin.toUpperCase()}
                  </p>
                </div>
                <div className="sc-items">
                  <p className="sc-item-title">
                    {" "}
                    Final {this.state.selectedCoin.toUpperCase()} Quantity
                  </p>
                  <p>
                    <span className="bold">
                      {Number(this.state.releaseAmount).toLocaleString()}
                    </span>{" "}
                    {this.state.selectedCoin.toUpperCase()}{" "}
                  </p>
                </div>
                <div className="sc-items">
                  <p className="sc-item-title"> Payment Method</p>
                  {this.state.paymentMethod === "bank-transfer" && (
                    <p>
                      <span className="bold ">Bank Transfer</span>
                    </p>
                  )}
                  {this.state.paymentMethod === "mobile-money" && (
                    <p>
                      <span className="bold ">Mobile Money</span>
                    </p>
                  )}
                </div>
                {this.state.paymentMethod === "bank-transfer" && (
                  <div className="sc-items">
                    <p className="sc-item-title"> Bank</p>
                    <p>
                      <span className="bold">{this.state.bank}</span>
                    </p>
                  </div>
                )}
                {this.state.paymentMethod === "bank-transfer" && (
                  <div className="sc-items">
                    <p className="sc-item-title"> Account Number</p>
                    <p>
                      <span className="bold">{this.state.accountNo}</span>
                    </p>
                  </div>
                )}
                {/* {this.state.paymentMethod === "bank-transfer" && (
                   <div className="sc-items">
                   <p className="sc-item-title">
                     {" "}
                    Account Name
                   </p>
                   <p>
                     <span className="bold">
                      {this.state.accountName}
                     </span>
                   </p>
                 </div>
                )} */}

                {this.state.paymentMethod === "mobile-money" && (
                  <div className="sc-items">
                    <p className="sc-item-title"> Phone number</p>
                    <p>
                      <span className="bold">{this.state.phone}</span>
                    </p>
                  </div>
                )}
                {this.state.paymentMethod === "mobile-money" && (
                  <div className="sc-items">
                    <p className="sc-item-title"> Network</p>
                    <p>
                      <span className="bold">{this.state.network}</span>
                    </p>
                  </div>
                )}

                <div className="sc-items">
                  <p className="sc-item-title"> Use Spot Rate</p>
                  <p>
                    <span className="bold">
                      {String(this.state.useSpotRate)}
                    </span>
                  </p>
                </div>
                <div className="sc-items">
                  <p className="sc-item-title"> Use Destination Value</p>
                  <p>
                    <span className="bold">
                      {String(this.state.useDestinationVolume)}
                    </span>
                  </p>
                </div>

                <div className="sc-items-last">
                  <p className="sc-item-title">Amount</p>
                  <p className="uppercase">
                    <span>
                      {Number(this.state.fiatAmount).toLocaleString()}{" "}
                    </span>{" "}
                    {this.state.selectedFiat}{" "}
                  </p>
                </div>
                <button
                  onClick={this.handleSummary}
                  className="summaryclicked-btn"
                >
                  Submit
                </button>
              </div>
            </section>
          </div>
        ) : null}

        {this.state.enterPin ? (
          <div>
            <div className="overlay3 animate__animated animate__fadeIn "></div>
            <section className="summaryclicked">
              <div className="summaryclicked-box2 animate__animated animate__slideInDown">
                <div className="sc-top">
                  <h2 className="">Enter Pin</h2>
                  <img
                    onClick={() => this.setState({ enterPin: false })}
                    src={Cancel}
                    alt="close"
                  />
                </div>
                <form
                  className="wallet-withdraw-form"
                  onSubmit={this.handlePinSubmit}
                >
                  <div className="ww-inputs">
                    <p>Please enter your pin for withdrawal</p>
                    <input
                      type="password"
                      placeholder="Enter your pin"
                      id="pin"
                      name="pin"
                      defaultValue={this.state.pin}
                      onChange={this.handleInputChange}
                      maxLength="6"
                      required
                    />
                    {/* <span className="password-btn">
                            <img className="show-icon" id="password-btn" src={Eye} alt="show"  />
                        </span> */}
                  </div>
                  {/* <span className="password-btn">
                        <img
                        className="show-icon"
                        id="password-btn"
                        src={Eye}
                        alt="show"
                        />
                    </span> */}
                  <p className="tiny-txt3 left-m1">
                    (Don't have a pin?{" "}
                    <span className="pointer green" onClick={this.createPin}>
                      Create one
                    </span>
                    )
                  </p>

                  <button
                    //onClick={this.handlePinSubmit}
                    className="summaryclicked-btn"
                    id="summaryBtn"
                  >
                    Submit
                  </button>
                  <div id="loadla" className="load-aa">
                    <img src={Load} alt="loading" />
                  </div>
                </form>
                <div
                  id="error-info"
                  className="error-info animate__animated animate__fadeIn "
                >
                  <p>{this.state.errorMessage}</p>
                </div>
              </div>
            </section>
          </div>
        ) : null}

        <section className="home">
          <div
            id="error-info2"
            className="err-auth zindex animate__animated animate__slideInDown"
          >
            <p>
              <strong>{this.state.incorrectError}</strong>
            </p>
          </div>
          <div className="home-container">
            <div className="home-buy-content">
              <Link to="/dashboard/home">
                <img src={Back} className="w-backarrow" alt="back" />
              </Link>
              <h1> Send </h1>
              <div className="home-nav">
                <Link to="/dashboard/home" className="right-e">
                  <p className="ash"> Home </p>
                </Link>
                <img className="right-e" src={Arrow} alt="" />
                <p>
                  <span className="bold"> Send</span>
                </p>
              </div>

              <div className="hr-boxes">
                <div
                  className={`hr-box-bg right-m0 ${
                    sendView === "viewing" ? "viewing" : ""
                  }`}
                  style={{ overflowY: "auto" }}
                >
                  {sendView === "viewing" ? (
                    <SendCard
                      sendData={sendData}
                      pageState={pageState}
                      homeClose={() => {
                        this.setState({ sendRef: "", setView: "create" });
                        this.props.history.push("/dashboard/homesend");
                      }}
                      setSendData={(sData) =>
                        this.setState({ sendData: sData })
                      }
                      setPageState={(pState) =>
                        this.setState({ pageState: pState })
                      }
                      homeSend
                      //   handleCancel={() => cancelReceivable(invoiceData?.ref)}
                    />
                  ) : (
                    <form onSubmit={this.handleSubmit}>
                      <p className="hr-txt label">You Send</p>
                      <div className="hw-double-inputs">
                        <select
                          className="hw-drop"
                          defaultValue={this.state.selectedCoin}
                          onChange={this.handleCoinChange}
                        >
                          <option value={process.env.REACT_APP_COIN_A}>
                            {" "}
                            {process.env.REACT_APP_COIN_A.toUpperCase()}{" "}
                          </option>
                          <option value={process.env.REACT_APP_COIN_B}>
                            {" "}
                            {process.env.REACT_APP_COIN_B.toUpperCase()}{" "}
                          </option>
                          <option value={process.env.REACT_APP_COIN_C}>
                            {" "}
                            {process.env.REACT_APP_COIN_C.toUpperCase()}{" "}
                          </option>
                          <option value={process.env.REACT_APP_COIN_D}>
                            {" "}
                            {process.env.REACT_APP_COIN_D.toUpperCase()}{" "}
                          </option>
                          <option value={process.env.REACT_APP_COIN_E}>
                            {" "}
                            cUSD
                          </option>
                          <option value={process.env.REACT_APP_COIN_F}>
                            {" "}
                            {process.env.REACT_APP_COIN_F.toUpperCase()}{" "}
                          </option>
                          <option value={process.env.REACT_APP_COIN_G}>
                            {" "}
                            {process.env.REACT_APP_COIN_G.toUpperCase()}{" "}
                          </option>
                          <option value={process.env.REACT_APP_COIN_H}>
                            {process.env.REACT_APP_COIN_H.toUpperCase()}
                          </option>
                          <option value={process.env.REACT_APP_COIN_I}>
                            {process.env.REACT_APP_COIN_I.toUpperCase()}
                          </option>
                          <option value={process.env.REACT_APP_COIN_L}>
                            cEUR
                          </option>
                        </select>
                        <input
                          type="text"
                          placeholder="Quantity"
                          name="coinAmount"
                          onChange={(e) => {
                            this.handleInputChange(e);
                            this.setState({ useDestinationVolume: false });
                          }}
                          ref={this.coinAmount}
                          defaultValue={this.state.coinAmount}
                        />
                        <div className="flex justify-between gap-4 items-center mt-2">
                          <p className="tiny-txt"></p>
                        </div>
                      </div>
                      <p className="hr-txt label">They receive</p>
                      <div className="hw-double-inputs">
                        <select
                          className="hw-drop"
                          defaultValue={this.state.selectedFiat}
                          onChange={this.handleFiatChange}
                        >
                          <option value={"ngn"}> NGN</option>
                          <option value={"ghs"}> GHS</option>
                        </select>
                        <input
                          type="text"
                          placeholder="Amount"
                          name="fiatAmount"
                          ref={this.fiatAmount}
                          onChange={(e) => {
                            this.handleInputChange(e);
                            this.setState({ useDestinationVolume: true });
                          }}
                          defaultValue={this.state.fiatAmount}
                        />
                      </div>
                      <div className="flex justify-between gap-4 items-center mt-2">
                        <p className="tiny-txt">
                          Rate: 1 {this.state.selectedCoin.toUpperCase()} ~{" "}
                          {Number(this.state.exchangeRate).toLocaleString()}{" "}
                          {this.state.selectedFiat.toUpperCase()}
                        </p>
                        <Toggle
                          handleToggleChange={({ value }) => {
                            if (value === "spotRate") {
                              this.setState({ useSpotRate: true });
                            } else {
                              this.setState({ useSpotRate: false });
                            }
                          }}
                          className="flex justify-center items-center"
                          labelClassName="text-sm"
                          options={[
                            { label: "Use current rate", value: "currentRate" },
                            {
                              label: "Use spot rate",
                              value: "spotRate",
                              checked: true,
                            },
                          ]}
                        />
                        {/* <Toggle
                        handleToggleChange={({ value }) => {
                          if (value === "receiversValue") {
                            this.setState({ useDestinationVolume: true });
                          } else {
                            this.setState({ useDestinationVolume: false });
                          }
                        }}
                        className="flex justify-center items-center"
                        labelClassName="text-sm"
                        options={[
                          {
                            label: "Use receiver's amount",
                            value: "receiversValue",
                          },
                          {
                            label: "Use senders amount",
                            value: "sendersValue",
                            checked: true,
                          },
                        ]}
                      /> */}
                      </div>
                      {/*<div className="hw-inputs">*/}
                      {/*  <p className="hr-txt">Amount to receive</p>*/}
                      {/*  <input type="text" placeholder="Amount" />*/}
                      {/*</div>*/}
                      {/* {this.state.selectedFiat === "ghs" && ( */}

                      <div className="hw-inputs">
                        <p className="hr-txt">Payment Method</p>
                        <select
                          className="hw-drop"
                          onChange={this.handlePaymentMethod}
                        >
                          {/* <PaymentMethods
                        options={
                          this.state.ghsStatus
                            ? [
                                {
                                  key: "bank-transfer",
                                  title: "Bank Transfer",
                                },
                                {
                                  key: "mobile-money",
                                  title: "Mobile Money",
                                },
                              ]
                            : [
                                { 
                                  key: "mobile-money", 
                                 title: "Mobile Money" 
                                }
                              ]
                        }
                      /> */}
                          {this.state.selectedFiat === "ghs" && (
                            <PaymentMethods
                              options={[
                                {
                                  key: "bank-transfer",
                                  title: "Bank Transfer",
                                },
                                {
                                  key: "mobile-money",
                                  title: "Mobile Money",
                                },
                              ]}
                            />
                          )}
                          {this.state.selectedFiat === "ngn" && (
                            <PaymentMethods
                              options={[
                                {
                                  key: "bank-transfer",
                                  title: "Bank Transfer",
                                },
                              ]}
                            />
                          )}
                        </select>
                      </div>
                      {/* )} */}
                      {this.state.paymentMethod === "bank-transfer" && (
                        <div>
                          <div className="hw-inputs">
                            <p className="hr-txt">Bank Transfer</p>
                            <select
                              className="hw-drop"
                              name="bank"
                              onChange={this.handleInputChange}
                            >
                              {/* <AllBanks /> */}
                              <option value="">Select Bank</option>
                              {this.state.banks.length
                                ? this.state.banks.map((item) => {
                                    return (
                                      <option
                                        value={
                                          item.bankName + "/" + item.bankCode
                                        }
                                        key={item.bankCode}
                                      >
                                        {item.bankName}
                                      </option>
                                    );
                                  })
                                : null}
                            </select>
                          </div>
                          <div className="hw-inputs">
                            <input
                              type="text"
                              name="accountNo"
                              onChange={this.handleInputChange}
                              placeholder="Account Number"
                            />
                          </div>
                          <div className="hw-inputs bold">
                            <input
                              type="text"
                              name="accountName"
                              value={this.state.accountName}
                              placeholder="Account Name"
                              disabled
                            />
                          </div>
                          <div className="hw-inputs">
                            <input
                              type="email"
                              name="email"
                              onChange={this.handleInputChange}
                              placeholder="Email"
                            />
                          </div>
                          {false && (
                            <>
                              <p className=" width-sm ">
                                {" "}
                                Wait Time(optional) if the request is not
                                processed within this time, then it will be
                                reversed, default is 48 hours.
                              </p>
                              <div className="hw-inputs">
                                {/* <p className="hr-txt width-sm"> Wait Time(optional) if the request is not processed within this time, then it will be reversed, default is 48 hours.</p> */}
                                <select
                                  className="hw-drop margin-top"
                                  name="waitTimeUnit"
                                  onChange={this.handleInputChange}
                                >
                                  <option value="">
                                    Select wait time unit
                                  </option>
                                  <option value="hours">Hours</option>
                                  <option value="minutes">Minutes</option>
                                </select>
                              </div>
                              <div className="hw-inputs">
                                {/* <p className="hr-txt width-sm"> Wait Time(optional) if the request is not processed within this time, then it will be reversed, default is 48 hours.</p> */}
                                <select
                                  className="hw-drop "
                                  name="waitTime"
                                  onChange={this.handleInputChange}
                                >
                                  <option value="">Select wait time </option>
                                  <option value="1">1</option>
                                  <option value="5">5</option>
                                  <option value="10">10</option>
                                  <option value="24">24</option>
                                  <option value="48">48</option>
                                </select>
                              </div>
                            </>
                          )}
                        </div>
                      )}
                      {this.state.paymentMethod === "mobile-money" &&
                        this.state.selectedFiat === "ghs" && (
                          <div>
                            <div className="hw-inputs">
                              <p className="hr-txt">Mobile Money</p>
                            </div>
                            <div className="hw-inputs">
                              <input
                                type="text"
                                name="phone"
                                onChange={this.handleInputChange}
                                placeholder="Phone Number"
                              />
                            </div>
                            <div className="hw-inputs">
                              <input
                                type="text"
                                name="network"
                                onChange={this.handleInputChange}
                                placeholder="Network"
                              />
                            </div>
                          </div>
                        )}

                      <button
                        id="wi-btn"
                        type="submit"
                        className="hr-btn-s w-disable"
                      >
                        {" "}
                        Send
                      </button>
                    </form>
                  )}
                </div>

                {/* Start send history  */}
                <div className="hr-box-sm">
                  <div className="wtb-top">
                    <h3> Send History </h3>
                  </div>
                  {/* Tranasaction tabs */}
                  <div className="tab-wrapper">
                    <div className="p2p-types-tabs">
                      <div
                        className={`p2p-type right-m0 ${
                          transactionsView === "closed" ? "type-active" : ""
                        }`}
                        onClick={() => {
                          this.setState({ transactionsView: "closed" });
                        }}
                      >
                        <p>Completed</p>
                      </div>
                      <div
                        className={`p2p-type ${
                          transactionsView === "pending" ? "type-active" : ""
                        }`}
                        onClick={() => {
                          this.setState({ transactionsView: "pending" });
                        }}
                      >
                        <p>Pending</p>
                      </div>
                      {this.state.processing && (
                        <div
                          className={`p2p-type ${
                            transactionsView === "processing"
                              ? "type-active"
                              : ""
                          }`}
                          onClick={() => {
                            this.setState({ transactionsView: "processing" });
                          }}
                        >
                          <p>Processing</p>
                        </div>
                      )}
                    </div>
                  </div>

                  {dataLoading ? (
                    <>
                      {/* Is loading  */}
                      <div className="loading-a" id="load">
                        <img src={Load} alt="loading" />
                      </div>
                    </>
                  ) : !allTx?.length ? (
                    <>
                      {/* No record  */}
                      <div className="wtb-single2">
                        <p className="wtb-title"> No record</p>
                      </div>
                    </>
                  ) : (
                    <>
                      {transactionsView === "closed" &&
                        allTx.map((tx) => (
                          <div
                            className="tx-single__wrap"
                            key={tx?._id}
                            onClick={() => {
                              this.props.history.push(
                                `/dashboard/homesend?id=${tx?._id}`
                              );
                              this.setState({ sendRef: tx?._id });
                            }}
                          >
                            <div className="wtb-single" key={tx?._id}>
                              <div className="wtb-single-info">
                                {tx?.outgoingState === "gone" ? (
                                  <img className="right-m1" src={Gdot} alt="" />
                                ) : (
                                  <img className="right-m1" src={Rdot} alt="" />
                                )}
                                <div className="wtb-single-desc">
                                  <p className="wtb-title">
                                    {" "}
                                    {tx?.outgoingState === "gone"
                                      ? `Sent ${Number(
                                          Number(
                                            tx?.destinationAmount ?? 0
                                          ).toFixed(8)
                                        )} `
                                      : `${properCase(
                                          tx.outgoingState
                                        )} sending ${Number(
                                          Number(
                                            tx?.destinationAmount ?? 0
                                          ).toFixed(8)
                                        )} `}
                                    {String(tx?.destinationUnit).toUpperCase()}{" "}
                                  </p>
                                  <p className="wtb-date">
                                    {tx?.createdAt?.substr(0, 10)}
                                  </p>
                                  <p className="mt-4 wtb-ref">
                                    <em>Ref:</em> {` ${tx?._id}`}
                                  </p>
                                </div>
                              </div>
                              {tx?.receipientData ? (
                                <div className="wtb-single-amount sender-user">
                                  <p className="bold">
                                    TO
                                    {` (${tx?.receipientData?.receivingMethod})`}
                                  </p>
                                  <div className="sender-name">{`${tx?.receipient?.name}`}</div>
                                  <div className="sender-name">
                                    {`${tx?.receipientData?.receivingIntoLabel}`}{" "}
                                    {`${tx?.receipientData?.receivingIntoAddress}`}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                            <p className="tx-desc">
                              {wordCut(tx?.remark, wordLen(), " ...")}
                            </p>
                          </div>
                        ))}
                      {transactionsView === "pending" &&
                        allTx.map((tx) => (
                          <div
                            className="tx-single__wrap"
                            key={tx?._id}
                            onClick={() => {
                              this.props.history.push(
                                `/dashboard/homesend?id=${tx?._id}`
                              );
                              this.setState({ sendRef: tx?._id });
                            }}
                          >
                            <div className="wtb-single">
                              <div className="wtb-single-info">
                                <img className="right-m1" src={Gdot} alt="" />
                                <div className=".wtb-single-desc">
                                  <p className="wtb-title">
                                    {" "}
                                    {tx?.outgoingState === "open"
                                      ? `Send ${Number(
                                          Number(
                                            tx?.destinationAmount ?? 0
                                          ).toFixed(8)
                                        )} `
                                      : `Sending ${Number(
                                          Number(
                                            tx?.destinationAmount ?? 0
                                          ).toFixed(8)
                                        )} `}
                                    {String(tx?.destinationUnit).toUpperCase()}{" "}
                                  </p>
                                  <p className="wtb-date">
                                    {tx?.createdAt?.substr(0, 10)}
                                  </p>
                                  <p className="mt-4 wtb-ref">
                                    <em>Ref:</em> {` ${tx?._id}`}
                                  </p>
                                </div>
                              </div>
                              {tx?.receipientData ? (
                                <div className="wtb-single-amount sender-user">
                                  <p className="bold">
                                    TO
                                    {` (${tx?.receipientData?.receivingMethod})`}
                                  </p>
                                  <div className="sender-name">{`${tx?.receipient?.name}`}</div>
                                  <div className="sender-name">
                                    {`${tx?.receipientData?.receivingIntoLabel}`}{" "}
                                    {`${tx?.receipientData?.receivingIntoAddress}`}
                                  </div>
                                </div>
                              ) : null}

                              <div className="pts-box">
                                {false && (
                                  <button
                                    onClick={() => {
                                      // if (!actionInProgress) {
                                      // cancelReceivable(tx?.ref);
                                      // }
                                    }}
                                    // disabled={!!actionInProgress}
                                    className="pts-cancel red"
                                  >
                                    Cancel
                                  </button>
                                )}
                              </div>
                            </div>

                            <p className="tx-desc">
                              {wordCut(tx?.remark, wordLen(), " ...")}
                            </p>
                          </div>
                        ))}
                    </>
                  )}
                  {!dataLoading && txCount > pageLimit ? (
                    <div className="paginate-box mt-4">
                      <p className="pts-max">
                        {`Page ${currentPage} of ${stPages}`}
                      </p>
                      <div className="paginate-actions">
                        {currentPage >= 2 && (
                          // <button onClick={this.prevPages}>Prev</button>
                          <img
                            className="paginate-arrows flip"
                            src={NextIcon}
                            onClick={this.prevPages}
                            alt="prev"
                          />
                        )}
                        {currentPage <= 1 && (
                          // <button onClick={this.prevPages}>Prev</button>
                          <img
                            className="paginate-dis"
                            src={Icon2}
                            alt="prev"
                          />
                        )}

                        {currentPage < stPages && (
                          <img
                            className="paginate-arrows"
                            src={NextIcon}
                            onClick={this.nextPages}
                            alt="next"
                          />
                        )}
                        {parseInt(currentPage) === parseInt(stPages) && (
                          <img
                            className="paginate-dis flip"
                            src={Icon2}
                            alt="next"
                          />
                        )}
                      </div>
                    </div>
                  ) : null}
                </div>
                {/* End send history tabs  */}
              </div>
            </div>
          </div>
        </section>
      </StyledDiv>
    );
  }
}
